import React from 'react';
import {Card, Col, Row, Spin, Typography} from 'antd';

import EngageCurrency from './EngageCurrency';
import {CurrentDepositParams} from '../../types/purchaseTypes';

const {Text} = Typography;

const CurrentDeposit = ({loading, curDepositValue}: CurrentDepositParams) => {
    return (
        <Col xs={24} sm={16} md={16} lg={12} xl={8}>
            <Card title="Current Deposit" className="details-card">
                <Spin spinning={loading}>
                    <Row>
                        <Col xs={24} md={12}>
                            <Text strong>Total amount:</Text>
                        </Col>
                        <Col xs={24} md={10}>
                            <EngageCurrency amount={curDepositValue}/>
                        </Col>
                    </Row>
                </Spin>
            </Card>
        </Col>
    )
}

export default CurrentDeposit;
